import { render } from "./PaymentCategories.vue?vue&type=template&id=ba5d8b12"
import script from "./PaymentCategories.vue?vue&type=script&lang=js"
export * from "./PaymentCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__